import types from '@client/redux/modules/mylounge-legacy/types';
import { fetchCampaignNotificationTags } from '@client/redux/modules/pushNotification/actions';
import {
    getCampaignTags,
    removeCampaignTag
} from './campaignTags';

let tagsRefreshed = false;

const setTagsRefreshed = () => {
    tagsRefreshed = true;
};

const clearSubscriptions = async(upcoming, appdomainId) => {
    const campaignIds = Object.keys(upcoming);
    const tags = await getCampaignTags(appdomainId);

    tags.filter((tag) => campaignIds.indexOf(tag) === -1)
        .forEach((tag) => removeCampaignTag(tag, appdomainId));

    setTagsRefreshed();
};

const emptyMiddleware = () => next => action => next(action);

export const pushNotificationMiddleware = (params = {}) => {
    const {
        initialUpcoming = {},
        appdomainId = null
    } = params;

    if (!appdomainId) {
        return emptyMiddleware;
    }

    if (initialUpcoming.campaigns) {
        clearSubscriptions(initialUpcoming.campaigns, appdomainId);

        return emptyMiddleware;
    }

    return ({ dispatch }) => next => action => {
        if (tagsRefreshed) {
            return next(action);
        }

        try {
            const { type, payload = {} } = action;
            if (type === types.UPDATE_MYLOUNGE.SUCCESS) {

                if (!payload.upcoming || !payload.upcoming.campaigns) {
                    return next(action);
                }

                const { upcoming: { campaigns } } = payload;
                clearSubscriptions(campaigns, appdomainId);
                dispatch(fetchCampaignNotificationTags(appdomainId));

            }
        }
        catch (e) {
            // TODO: change to logger
            // eslint-disable-next-line no-console
            console.error(e);
        }

        return next(action);
    };
};
